import { createTw } from 'react-pdf-tailwind';

import config from '../../tailwind.config.js';

export const tw = createTw(config);
